import React from 'react';
import PropTypes from 'prop-types';

import cssVars from '../../../assets/export.css';
import './Headline.css';

/**
 * A simple Headline (h1 to h6).
 */

const Headline = ({ typeOf, color, style, alignment, children }) => {
	const HeadlineTag = `${typeOf}`;
	
	var styles = Object.assign(style, {
      color: color,
      textAlign: alignment
    });

	return (


		<HeadlineTag style={styles} className="heading">{children}</HeadlineTag>
	)
}

Headline.propTypes = {
	/** Text */
	children: PropTypes.string.isRequired,
	/** Label Color */
	color: PropTypes.string,
	/** Type of Headline */
	typeOf: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
	/** Alignment of Headline */
	alignment: PropTypes.oneOf(['left', 'right', 'center']),
	/** Custom styles of Headline */
	style: PropTypes.object,
}

Headline.defaultProps = {
	color: cssVars.headlinePrimary,
	typeOf: "h1",
	alignment: "left",
	style: {}
}

export default Headline;


// WEBPACK FOOTER //
// ./src/components/atoms/Headline/Headline.js